import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { fetchCountries } from 'lib/core/data/common/countryList'
import { getSlice as getCountryList, getCountryOptions } from 'lib/core/data/common/countryList/selectors'
import { fetchCountryInfo } from 'lib/core/data/common/countryInfo'
import { getCountryConfig } from 'lib/core/data/common/storeConfig/selectors'
import { getCountryInfoOptions, getRegionOptions, getIsFetching } from 'lib/core/data/common/countryInfo/selectors'
import { MagentoCountryCodeEnum } from 'lib/types'

interface Deps {
  countryCode?: string
}

export const useDirectoryOptions = (deps?: Deps) => {
  const dispatch = useDispatch()
  const countryCode = deps?.countryCode
  const countryConfig = useSelector(getCountryConfig)
  const { isFetching: countryOptionsIsFetching } = useSelector(getCountryList)
  const countryInfoOptions = useSelector(getCountryInfoOptions)
  const countryOptions = useSelector(getCountryOptions)
  const regionOptions = useSelector(getRegionOptions(countryCode))
  const countryInfoIsFetching = useSelector(getIsFetching(countryCode ? [countryCode] : []))

  const _countryInfoOptions = [...countryInfoOptions]
  const _countryOptions = [...countryOptions]
  const _regionOptions = [...regionOptions]

  _countryInfoOptions.unshift({ label: '', value: MagentoCountryCodeEnum.EMPTY })
  _countryOptions.unshift({ label: '', value: MagentoCountryCodeEnum.EMPTY }) // Include empty option
  _regionOptions.unshift({ id: -1, label: '', value: '' }) // Include empty option

  useEffect(() => {
    dispatch(fetchCountries())
  }, [
    dispatch
  ])

  useEffect(() => {
    if (countryCode) {
      dispatch(fetchCountryInfo(countryCode))
    }
  }, [
    countryCode,
    dispatch
  ])

  return {
    countryInfoOptions: _countryInfoOptions,
    countryInfoIsFetching,
    countryOptions: _countryOptions,
    countryOptionsIsFetching,
    regionOptions: _regionOptions,
    regionIsRequired: countryCode ? Boolean(countryConfig.regionRequired[countryCode]) : false,
    postalCodeIsOptional: countryCode ? Boolean(countryConfig.postalCodeOptional[countryCode]) : false
  }
}
